import * as K from 'common/constants';
import BootstrapForm from 'react-bootstrap/Form';
import ELEMENT from 'common/element';
import CheckboxRadio from 'components/common/CheckboxRadio/CheckboxRadio';
import { BarWidth } from 'components/common/Graphs/GraphStyleDropdown/GraphStyleDropdown';
import Select from 'components/common/ReactSelect/Select';

import './GraphDisplaySettings.scss';

type LineSettingsMenuProps = {
  lineSmoothing: string;
  yScale: string;
  barWidth?: BarWidth;
  barWidthOptions?: Array<BarWidth>;
  setLineSmoothing: (lineSmoothing: string) => void;
  setYScale: (setYScale: string) => void;
  setBarWidth?: (barWidth: BarWidth) => void;
};

/**
 * Menu for editing Line/ Area chart display settings
 */
function LineSettingsMenu({
  lineSmoothing,
  yScale,
  barWidth,
  barWidthOptions,
  setLineSmoothing,
  setYScale,
  setBarWidth,
}: LineSettingsMenuProps) {
  const formRadios = {
    style: [
      { label: 'Straight', value: K.LINE_OPTIONS.STRAIGHT_LINES, testId: ELEMENT.graphDisplaySettingsStraight },
      { label: 'Smooth', value: K.LINE_OPTIONS.SMOOTH_CURVES, testId: ELEMENT.graphDisplaySettingsSmooth },
    ],
    scale: [
      { label: 'Linear', value: K.Y_SCALE_OPTIONS.LINEAR, testId: ELEMENT.graphDisplaySettingsLinear },
      { label: 'Logarithmic', value: K.Y_SCALE_OPTIONS.LOGARITHMIC, testId: ELEMENT.graphDisplaySettingsLogarithmic },
    ],
  };

  return (
    <div className="GraphDisplaySettings__Body">
      {barWidth && setBarWidth && (
        <BootstrapForm.Group className="GraphDisplaySettings__FormGroup">
          <BootstrapForm.Label className="GraphDisplaySettings__FormLabel">Interval</BootstrapForm.Label>
          <Select
            options={barWidthOptions}
            defaultValue={{ value: barWidth.value, label: barWidth.label }}
            onChange={(width) => setBarWidth(width as BarWidth)}
          />
        </BootstrapForm.Group>
      )}
      <BootstrapForm.Group className="GraphDisplaySettings__FormGroup">
        <BootstrapForm.Label className="GraphDisplaySettings__FormLabel">Style</BootstrapForm.Label>
        <div>
          {formRadios.style.map((radio, idx) => (
            <CheckboxRadio
              key={`Style-${idx}`}
              type="radio"
              name="Style"
              label={radio.label}
              onChange={() => setLineSmoothing(radio.value)}
              checked={lineSmoothing === radio.value}
              value={radio.value}
              testId={radio.testId}
            />
          ))}
        </div>
      </BootstrapForm.Group>
      <BootstrapForm.Group className="GraphDisplaySettings__FormGroup">
        <BootstrapForm.Label className="GraphDisplaySettings__FormLabel">Scale</BootstrapForm.Label>
        <div>
          {formRadios.scale.map((radio, idx) => (
            <CheckboxRadio
              key={`Style-${idx}`}
              type="radio"
              name="Scale"
              label={radio.label}
              onChange={() => setYScale(radio.value)}
              checked={yScale === radio.value}
              value={radio.value}
              testId={radio.testId}
            />
          ))}
        </div>
      </BootstrapForm.Group>
    </div>
  );
}

export default LineSettingsMenu;
